import { Item } from '@factorialco/deprecated-design-system'
import {
  ApiCoreCompany,
  IntegrationsDatevLaudsBusinessUnit,
  IntegrationsDatevLaudsSalaryType,
} from 'generated/resources/graphql'

import { DatevWizardData } from 'modules/payroll_integrations_datev_lauds/lib/types'

export type ClientDataProps = {
  businessUnits: Item[]
  salaryTypes: Item[]
  loading: boolean
}

export interface ClientDataResultProps {
  salaryTypesOptions: IntegrationsDatevLaudsSalaryType[]
  businessUnitsOptions: IntegrationsDatevLaudsBusinessUnit[]
  clientId: string
}

export const modifiedClientData = (
  clientData: IntegrationsDatevLaudsBusinessUnit[] | IntegrationsDatevLaudsSalaryType[]
): Item[] =>
  clientData.map(({ id, name }) => ({
    value: id,
    label: name,
  }))

export const getMatchedLegalEntities = (data: DatevWizardData, company: ApiCoreCompany) => {
  const legalEntitiesKeys = Object.keys(data.answers).filter(
    (key) => /^legal_entity_\d+$/.test(key) && !!data.answers[key]
  )
  const mappedLegalEntityIds = legalEntitiesKeys.map((key) => key.split('_')[2])
  return company.legalEntities
    .filter((legalEntity) => mappedLegalEntityIds.includes(legalEntity.id.toString()))
    .map((legalEntity) => legalEntity)
}
